import { namespace } from 'vuex-class';
import { IDocumentEditState } from './document-edit.types';

export const documentEditNamespace = 'documentEdit';

export const DocumentEdit = namespace(documentEditNamespace);

export const state: IDocumentEditState = {
  isAddingRecipient: false,
  isLoadingRecipients: false,
  recipients: [],
  isSigning: false,
  isSigningOrder: false,
  isLoadingDocument: false,
  isSelfsign: false,
  documentType: 'sales',
  sender: {
    email: '',
    name: '',
    thumbUrl: '',
    senderId: '',
  },
  videoId: '',
  isVideo: false,
  id: '',
  activeTab: 'recipients',
  error: false,
};

export enum EDocumentEditMutation {
  AddingRecipient = 'addingRecipient',
  LoadingRecipients = 'loadingRecipients',
  SetRecipients = 'setRecipients',
  SetIsSigning = 'setIsSigning',
  LoadDocumentData = 'loadingDocument',
  SetDocumentData = 'setDocument',
  SetIsSigningOrder = 'setIsSigningOrder',
  SetIsSelfsign = 'setIsSelfsign',
  SetSender = 'setSender',
  RemoveVideo = 'removeVideo',
  SetVideo = 'setVideo',
  SetNewType = 'setNewType',
  InitalizeDocumentEdit = 'initializeDocumentEdit',
  SetDocumentId = 'setDocumentId',
  SetActiveTab = 'setActiveTab',
  SetError = 'setError',
}

export enum EDocumentEditAction {
  SetRecipients = 'setRecipients',
  SetIsSigning = 'setIsSigning',
  SetIsSigningOrder = 'setIsSigningOrder',
  LoadDocumentData = 'loadLegacyDocument',
  SetIsSelfsign = 'setIsSelfsign',
  SetRecipientsSigningOrders = 'setRecipientsSigningOrder',
  SetRecipientSigningOrder = 'setRecipientSigningOrder',
  RemoveVideo = 'removeVideo',
  SetVideoToDocument = 'setVideoToDocument',
  InitializeDocumentEdit = 'initializeDocumentEdit',
  SetNewType = 'setNewType',
  CreateDocument = 'createDocument',
  CreateDocumentSuccess = 'createDocumentSuccess',
  CreateDocumentFailed = 'createDocumentFailed',
  SetActiveTab = 'setActiveTab',
  ResetError = 'resetError',
}

export enum EDocumentEditGetter {
  SignerCount = 'signerCount',
  ApproverCount = 'approverCount',
}
